document.addEventListener('DOMContentLoaded', async function () {
  async function handleRenderCartDiscountCodes() {

    const GROWAVE_REWARD_TITLES_POINTS_RELATED = [
      "Amount discount"
    ]

    fetch("/cart?section_id=discount-applications")
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const discountApplications = JSON.parse(
          doc.querySelector("script#discount-applications")?.innerHTML || '[]'
        )?.discountApplications || [];

        const gwAvailableDiscountCodes = JSON.parse(
          doc.querySelector("script#gw-available-discount-codes")?.innerHTML || '[]'
        )?.gwAvailableDiscountCodes || [];

        // New discounts created by Growave but not checked the validation yet 
        const newDiscountCodes = discountApplications.filter(code => !gwAvailableDiscountCodes.includes(code));
        return newDiscountCodes;
      })
      .then(async (discountCodes = []) => {
        if (discountCodes.length <= 0) return;
        const data = {
          rewards: [
            {
              type: "discount",
              codes: discountCodes
            }
          ]
        }
        const url = window.middlewareUrls.discountCodesDetails;
        const getDiscountCodeDetailRes = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ codes: discountCodes })
        })
        if (!getDiscountCodeDetailRes.ok) throw new Error("Network response was not ok");
        const getDiscountCodeDetailResJson = await getDiscountCodeDetailRes.json();
        const discountDetail = getDiscountCodeDetailResJson.data;
        let shouldContinueDiscountValidation = discountDetail &&
          !!GROWAVE_REWARD_TITLES_POINTS_RELATED.find(
            title => discountDetail?.codeDiscount?.title?.trim()?.includes(title.trim())
          );
        return shouldContinueDiscountValidation ? data : null;
      })
      .then(res => {
        if (!res) {
          console.log("The discount code is not related to points redemption, skip validating with CA");
          return null;
        }
        return fetch(window.middlewareUrls.pointRedeem, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(res)
        })
      })
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(res => {
        if (res.status !== 200) throw new Error("Middleware response error");
        console.log("Discount codes redeemed successfully:", res);
        return fetch("/cart?section_id=cart-drawer");
      })
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        cart.innerHTML = doc.querySelector('cart-notification, cart-drawer').innerHTML;
        cart.classList.toggle("is-empty",
          doc.querySelector('cart-notification, cart-drawer').classList.contains("is-empty")
        )
        // delay 250ms to ensure cart is updated before opening

        // setTimeout(() => {
        //   window.gw.sdk.rewards.methods.closeRewardsPopup();
        //   cart.open()
        // }, 250)
      })
      .catch(err => {
        console.error("Error redeeming discount codes:", err);
      })
  }

  function onSdkReady() {
    const moduleName = window.gw.sdk.common.constants.modules.REWARDS;
    window.gw.sdk.runIfModuleReady(moduleName, () => {

      window.gw.sdk.on(window.gw.sdk.rewards.events.POPUP_WIDGET_VIEW_CHANGED, (e) => {
        const view = e.detail.view;
        if (view !== "customerRewards") return;

        // Attach click event to shadow root to catch events from elements inside shadow DOM
        const shadowRoot = document
          .querySelector(".gw-rd-popup-widget-placeholder")
          ?.shadowRoot;

        if (shadowRoot) {
          shadowRoot.addEventListener("click", (event) => {
            const redeemBtn = event.target.matches('.gw-rd-list__item [data-gw-selector^="gw-customer-rewards-popup-"] .gw-rd-popup-widget-card__collapsible-content .gw-btn');
            console.log("Redeem button clicked:", redeemBtn);
            if (redeemBtn) {
              handleRenderCartDiscountCodes();
            }
          });
        }
        window.gw.sdk.rewards.methods.getCustomerActiveRewards("en")
          .then(res => {
            if (res.status !== "success") return null;
            return res.result?.filter(item => item.type === "redeem")
          })
          .then(res => {
            if (!res || res.length === 0) return [];
            // id = discount-applications, a section in sections theme, fetch in first time load page
            handleRenderCartDiscountCodes();
          })
          .catch(err => {
            console.error("Error redeeming discount codes:", err);
          })
      });
    });
  }
  if (window.gw && window.gw.sdk) {
    onSdkReady();
  } else {
    document.addEventListener("gwSdkReady", onSdkReady);
  }
})